export const TASKS_WIDGET_NAMESPACE = 'widget.tasks'
